import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRobot = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 24,
	height: 24,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M6 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 12v9" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 12v9" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 16l4 -2" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 14l4 2" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 18h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 8v.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 8v.01" })
	]
});
const ForwardRef = forwardRef(SvgRobot);
export default ForwardRef;
